import React from 'react';
import { useTranslation } from 'react-i18next';

import { changeDateFormat } from '../../shared-functions/DateTime';

import CustomDatePicker from './CustomDatePicker';

interface CustomDateRangeProperties {
  inputLabel?: string;
  value1: string;
  value2: string;
  name1: string;
  name2: string;
  onChangeValue: (name: string, value: string) => void;
  valueRequired?: boolean;
  readOnly?: boolean;
  isFutureDateDisabled?: boolean;
}

/**
 * Custom Date Range function component
 * @param {any} param0 - The param0
 * @param {any} param0.inputLabel - The inputLabel prop
 * @param {any} param0.name1 - The name1 prop
 * @param {any} param0.name2 - The name2 prop
 * @param {any} param0.value1 - The value1 prop
 * @param {any} param0.value2 - The value2 prop
 * @param {any} param0.onChangeValue - The onChangeValue prop
 * @param {any} param0.valueRequired - The valueRequired prop
 * @param {any} param0.readOnly - The readOnly prop
 * @param {any} param0.isFutureDateDisabled - The isFutureDateDisabled prop
 */
function CustomDateRange({
  inputLabel,
  name1,
  name2,
  value1,
  value2,
  onChangeValue,
  valueRequired,
  readOnly,
  isFutureDateDisabled,
}: CustomDateRangeProperties) {
  const { t } = useTranslation('sharedComp');

  /**
   * Date Range field handle function
   * @param {any} name - The name
   * @param {any} changeValue - The changeValue
   */
  const handleValueChange = (name: string, changeValue: string) => onChangeValue(name, changeValue);

  const today = isFutureDateDisabled ? changeDateFormat(new Date().toString()) : '';

  return (
    <div className="custom-input-date-wrap">
      {inputLabel && (
        <p className="input-label">
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className="custom-date-input">
        <CustomDatePicker
          name={name1}
          placeholder={t('from')}
          value={value1}
          readOnly={readOnly}
          onChangeValue={handleValueChange}
          maxDate={isFutureDateDisabled ? today : ''}
        />
        <CustomDatePicker
          name={name2}
          placeholder={t('to')}
          value={value2}
          readOnly={readOnly}
          onChangeValue={handleValueChange}
          minDate={isFutureDateDisabled ? value1 : ''}
          maxDate={isFutureDateDisabled ? today : ''}
        />
      </div>
    </div>
  );
}

CustomDateRange.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  readOnly: false,
  isFutureDateDisabled: false,
};

export default CustomDateRange;
